import React from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBagIcon, XIcon } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { formatPrice } from "../utils/format";
import { btnPrimary, btnSecondary, ease } from "../utils/styles";
import { CartLine } from "./CartLine";
export function CartDrawer() {
  const {
    items,
    isOpen,
    close,
    subtotal,
    count
  } = useCart();
  return <AnimatePresence data-id="element-31" data-mp="304kungzuatwf">
      {isOpen && <>
          <motion.div className="fixed inset-0 z-50 bg-ink/30 backdrop-blur-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={close} data-id="element-32" data-mp="35005e02jw9om" />
          <motion.aside role="dialog" aria-modal="true" aria-label="Winkelwagen" className="fixed inset-y-2 right-2 z-50 flex w-[calc(100%-16px)] max-w-md flex-col rounded-3xl bg-paper" initial={{
        x: "105%"
      }} animate={{
        x: 0
      }} exit={{
        x: "105%"
      }} transition={{
        duration: 0.28,
        ease
      }} data-id="element-33" data-mp="2va74bt01bcym">
            <div className="flex items-center justify-between px-6 pb-2 pt-5" data-id="element-34" data-mp="3vaaaxe412133">
              <h2 className="text-xl font-medium tracking-[-0.02em] text-ink" data-id="element-35" data-mp="cv9hueascyzz">
                Winkelwagen <span className="text-muted" data-id="element-36" data-mp="83rg3o0xuudy">{count}</span>
              </h2>
              <button type="button" onClick={close} className="flex h-10 w-10 items-center justify-center rounded-full bg-sand hover:bg-stone" aria-label="Sluiten" data-id="element-37" data-mp="mt73qv56ajpf">
                <XIcon className="h-5 w-5" data-id="element-38" data-mp="htuj8h1rxoq0" />
              </button>
            </div>

            {items.length === 0 ? <div className="flex flex-1 flex-col items-center justify-center px-8 text-center" data-id="element-39" data-mp="vrj3pnrxituj">
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-sand" data-id="element-40" data-mp="rqfql919nbx0">
                  <ShoppingBagIcon className="h-6 w-6 text-muted" strokeWidth={1.6} data-id="element-41" data-mp="2xn1tpvb27e6w" />
                </span>
                <p className="mt-4 text-lg font-medium text-ink" data-id="element-42" data-mp="wj0sjlgx2hjj">Nog niets gekozen</p>
                <p className="mt-1 text-sm text-muted" data-id="element-43" data-mp="wldhiil3ds63">Ontdek onze lampen en persoonlijke cadeaus.</p>
                <Link to="/shop" onClick={close} className={`${btnPrimary} mt-6`} data-id="element-44" data-mp="11jx4mmbf9a01">
                  Naar de shop
                </Link>
              </div> : <>
                <ul className="flex-1 overflow-y-auto px-6" data-id="element-45" data-mp="1be70idzkoqfi">
                  <AnimatePresence initial={false} data-id="element-46" data-mp="1fh3l2a8oawm3">
                    {items.map(item => <CartLine key={item.key} item={item} compact data-id="element-47" data-mp="1kfn9qienimi5" />)}
                  </AnimatePresence>
                </ul>
                <div className="m-2 rounded-2xl bg-sand p-5" data-id="element-48" data-mp="1pa0zo5ajo1ff">
                  <div className="flex justify-between text-[15px]" data-id="element-49" data-mp="1u685ly2xxcxd">
                    <span className="text-muted" data-id="element-50" data-mp="1z6ngmizr28c6">Subtotaal</span>
                    <span className="font-medium text-ink" data-id="element-51" data-mp="1z41c6s85o8y6">{formatPrice(subtotal)}</span>
                  </div>
                  <p className="mt-1 text-xs text-muted" data-id="element-52" data-mp="3np8gojaks97i">Incl. btw, verzending bij afrekenen</p>
                  <div className="mt-4 grid grid-cols-2 gap-2" data-id="element-53" data-mp="3jnwqabjvnjy9">
                    <Link to="/winkelwagen" onClick={close} className={`${btnSecondary} bg-paper hover:bg-stone`} data-id="element-54" data-mp="3jmlkk66vg24i">
                      Bekijk
                    </Link>
                    <Link to="/winkelwagen" onClick={close} className={btnPrimary} data-id="element-55" data-mp="39qqw2ufyvctt">
                      Afrekenen
                    </Link>
                  </div>
                </div>
              </>}
          </motion.aside>
        </>}
    </AnimatePresence>;
}